import { render, staticRenderFns } from "./NormalSearchNav287.vue?vue&type=template&id=1938b7fd&scoped=true"
import script from "./NormalSearchNav287.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav287.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938b7fd",
  null
  
)

export default component.exports